export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/stoichiometry/lead_precip/configuration.json";